
export const COLOR_PALETTES: Record<string, string[]> = {
    // Vibrant and distinct colors for maximum differentiation
    vibrant: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B739', '#52B788'],

    // Professional business colors
    business: ['#2E86AB', '#A23B72', '#F18F01', '#C73E1D', '#6A994E', '#BC4B51', '#5B8E7D', '#8B7E74', '#C9ADA7', '#4A5759'],

    // Warm sunset palette
    sunset: ['#FF6B35', '#F7931E', '#FDC830', '#F37335', '#C9485B', '#9C3848', '#6A2E35', '#FFB84D', '#FF8552', '#E63946'],

    // Cool ocean palette
    ocean: ['#06AED5', '#086788', '#0496FF', '#7209B7', '#3A0CA3', '#4361EE', '#4CC9F0', '#00B4D8', '#0077B6', '#023E8A'],

    // Nature/Earth tones
    nature: ['#52B788', '#74C69D', '#95D5B2', '#B7E4C7', '#D8F3DC', '#40916C', '#2D6A4F', '#1B4332', '#081C15', '#52796F'],

    // Original palettes (kept for compatibility)
    indigo: ['#4f46e5', '#6366f1', '#818cf8', '#a5b4fc', '#c7d2fe', '#1e40af', '#3730a3', '#312e81'],
    teal: ['#0d9488', '#14b8a6', '#2dd4bf', '#5eead4', '#99f6e4', '#115e59', '#0f766e', '#134e4a'],
    crimson: ['#dc2626', '#ef4444', '#f87171', '#fca5a5', '#fecaca', '#991b1b', '#7f1d1d', '#450a0a'],
    amber: ['#b45309', '#d97706', '#f59e0b', '#fbbf24', '#fde68a', '#78350f', '#92400e', '#451a03'],
    gold: ['#B8860B', '#DAA520', '#D4AF37', '#FFD700', '#FFE08A', '#8B7500', '#F4C430', '#FFDF00'],
    neutral: ['#0f172a', '#1f2937', '#334155', '#475569', '#64748b', '#94a3b8', '#cbd5e1', '#e2e8f0'],

    // Force Graph specific palettes
    force_vibrant: ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B739', '#52B788'],
    force_cool: ['#4CC9F0', '#4361EE', '#3A0CA3', '#7209B7', '#F72585', '#4895EF', '#560BAD', '#B5179E', '#3F37C9', '#480CA8'],
};

export const DEFAULT_PALETTE = 'vibrant';
export const CHART_COLORS = COLOR_PALETTES[DEFAULT_PALETTE];
